import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import { OnboardingController } from "@/modules/onboarding/OnboardingController";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

export default function Onboarding() {
  const canViewOnboarding = useHasPermission(Permission.ONBOARDING_VIEW);

  if (!canViewOnboarding) {
    return (
      <AccessRestricted
        breadcrumbs={[{ label: "Onboarding", current: true }]}
        message="You do not have permission to view onboarding."
      />
    );
  }

  return (
    <Layout breadcrumbs={[{ label: "Onboarding", current: true }]}>
      <div className="p-6">
        <OnboardingController />
      </div>
    </Layout>
  );
}
